import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../api/client';
import { StatusPedidoDTO, Pedido } from '../types';
import toast from 'react-hot-toast';
import { extractErrorMessage } from '../utils/errorHandler';

export const useStatusPedidos = () => {
  return useQuery({
    queryKey: ['status-pedidos'],
    queryFn: async () => {
      const response = await api.get<StatusPedidoDTO[]>('/status-pedidos');
      return response.data;
    },
    staleTime: 5 * 60_000,
  });
};

export const useAlterarStatusPedido = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ pedidoId, novoStatusId }: { pedidoId: number; novoStatusId: number }) => {
      const response = await api.patch(`/pedidos/${pedidoId}/status`, { novoStatusId });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pedidos'] });
      queryClient.invalidateQueries({ queryKey: ['pedidos-do-dia'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      toast.success('Status do pedido alterado com sucesso!');
    },
    onError: (error: any) => {
      toast.error(extractErrorMessage(error, 'Erro ao alterar status do pedido'));
    },
  });
};

export const usePedidos = () => {
  return useQuery({
    queryKey: ['pedidos'],
    queryFn: async () => {
      const response = await api.get<{ pedidos: Pedido[] }>('/pedidos');
      return response.data.pedidos;
    },
  });
};

export const usePedidosDoDia = (pagina: number = 1, tamanhoPagina: number = 20) => {
  return useQuery({
    queryKey: ['pedidos-do-dia', pagina, tamanhoPagina],
    queryFn: async () => {
      try {
        const response = await api.get<{
          pedidos: Pedido[];
          totalCount: number;
          totalPaginas: number;
        }>('/pedidos/do-dia', {
          params: { pagina, tamanhoPagina },
        });
        return response.data;
      } catch (error: any) {
        console.error('Erro ao buscar pedidos do dia:', error.response?.status, error.response?.data);
        toast.error(`Erro ao carregar pedidos: ${error.response?.status === 404 ? 'Endpoint não encontrado. Reinicie a API.' : error.message}`);
        throw error;
      }
    },
    retry: false,
  });
};
